/**
 * A lazily loaded chunk that could not be fetched - typically a deploy
 * replaced the hashed file this tab still refers to. Retrying renders the
 * same failed import (React.lazy keeps it), so only a reload helps.
 * Messages: Chromium, Safari, Firefox; `ChunkLoadError` from older bundlers.
 *
 * @param {unknown} error
 * @returns {boolean}
 */
export function isChunkLoadError(error) {
  const message = String(error?.message || '')
  return error?.name === 'ChunkLoadError'
    || /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message)
}
